import React, { useEffect, useState, useRef, useContext } from "react";

import {
    AccesibilidadContext,
    FuentesDisponibles,
    TemasDisponibles,
} from "../../contexts/AccesibilidadContext";

import { Icon } from "@iconify/react";
import { FocusScope } from "react-aria";

import { useAccessibility } from "../../hooks/useAccessibility";
import { useTranslations } from "../../hooks/use-translations";


import { store } from "../Store";
import useIsMobile from "../../js/utilities/useIsMobile";
import { useLanguage } from "../../hooks/use-language";

/**
 * Menu que contiene la configuración de accesibilidad del sitio
 * @returns {React.Component}
 */
export const Accessibility = () => {
    const lang = useLanguage();
    const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

    const accebilidadState = useContext(AccesibilidadContext);
    const [esTemaClasico, setEsTemaClasico] = useState(true);
    const InputTamanoref = useRef(null);
    const InputSpacioref = useRef(null);

    const showAccessibility = useAccessibility();
    const visible = showAccessibility?.state?.visible;
    const globalState = useContext(store);
    const triggerButton = globalState?.state?.accessibility?.triggerButton;
    const ref = useRef(null);

    const isMobile = useIsMobile();

    const hide = () => {
        showAccessibility.setVisible(false);
    }

    const handleOutsideClick = (event) => {
        if (triggerButton?.current?.contains(event.target)) return;
        if (ref.current && !ref.current.contains(event.target)) {
            showAccessibility.setVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [triggerButton]);


    /**Cada vez que se monte este componente se activara el focus en el input tamaño de fuente */
    useEffect(() => {
        if (InputTamanoref.current) {
            InputTamanoref.current.focus();
        }
    }, []);

    /*al hacer scroll se actualiza el estado de mostrar u ocultar el panel de accesibilidad */
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                showAccessibility.setVisible(false);
            }
        });
    }, [visible]);

    /**Actualiza el estado temaClasico */
    useEffect(() => {
        let tema = accebilidadState?.temaActual !== "clasico" ? false : true;
        setEsTemaClasico(tema);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accebilidadState]);

    const cambiarTipoFuente = (valor) => {
        accebilidadState.actualizarFuente(valor || "predeterminado");
    };

    const cambiarTamanoFuente = (valor) => {
        accebilidadState.actualizarTamanioFuente(valor);
    };

    const cambiarEspacioTexto = (valor) => {
        accebilidadState.actualizarEspacioTexto(valor);
    };

    const cambiarTema = (valor) => {
        accebilidadState.actualizarTema(valor);
    };

    const restablecerConfiguracion = () => {
        accebilidadState.actualizarTema(TemasDisponibles.clasico.id);
        accebilidadState.actualizarTamanioFuente(16);
        accebilidadState.actualizarFuente(FuentesDisponibles.predeterminado.id);
        accebilidadState.actualizarEspacioTexto(2);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            showAccessibility.setVisible(false);
        }
    };

    return (
        <>
            <div className={`menu-accesibilidad-flotante ${visible === false && 'collapsedMode'}`}>
                {visible && (
                    <FocusScope contain restoreFocus autoFocus>
                        <section
                            ref={ref}
                            onClick={(e) => e.target === e.currentTarget && hide()}
                            className={`menu-accesibilidad ${visible ? "expanded" : "collapsed"
                                } text-fontSize`}
                            onKeyDown={handleKeyDown}
                        >
                            {/*
                            isMobile &&
                            <div className="item-languaje">
                                <p className="text-idioma d-none d-md-block">
                                    {textosInterfaz?.idioma || "Idioma:"}{" "}
                                </p>
                                <div className="d-flex justify-content-center align-items-center">
                                    <LanguageSelector />
                                </div>
                            </div>
                        */}


                            <div className="item">
                                <label htmlFor="tamanoFuente" className="label text-fontSize">
                                    {textosInterfaz?.tamano_fuente || "Tamaño de fuente:"}{" "}
                                    {/* <strong className="numeroPx onprimary-color">
								<span>{accebilidadState?.tamanioFuente}</span>px
							</strong> */}
                                </label>
                                <input
                                    id="tamanoFuente"
                                    type="range"
                                    min="16"
                                    max="32"
                                    step="2"
                                    value={accebilidadState?.tamanioFuente}
                                    ref={InputTamanoref}
                                    aria-valuenow={accebilidadState?.tamanioFuente}
                                    aria-valuemin="16"
                                    aria-valuemax="32"
                                    aria-label={textosInterfaz?.tamano_fuente || "Tamaño de fuente:"}
                                    className={`focusable-red range-slider__range_settings ${!esTemaClasico && "onbackground-primary--bordered"
                                        }`}
                                    onChange={(e) => {
                                        cambiarTamanoFuente(e.currentTarget.value);
                                    }}
                                />
                                <output
                                    className="d-none d-xl-flex px-0 primary-inverse--color"
                                    style={{ fontSize: "16px" }}
                                    htmlFor="tamanoFuente"
                                >
                                    <div className="col-6 px-0">100%</div>
                                    <div className="col-6 px-0 d-flex justify-content-end">150%</div>
                                </output>
                            </div>

                            <div className="item">
                                <label htmlFor="espacioTexto" className="label text-fontSize">
                                    {textosInterfaz?.espaciado_texto || "Espaciado de texto:"}{" "}
                                </label>
                                <input
                                    id="espacioTexto"
                                    type="range"
                                    min="2"
                                    max="8"
                                    step="2"
                                    value={accebilidadState?.espacioTexto}
                                    ref={InputSpacioref}
                                    aria-valuenow={accebilidadState?.espacioTexto}
                                    aria-valuemin="2"
                                    aria-valuemax="8"
                                    aria-label={textosInterfaz?.espaciado_texto || "Espaciado de texto:"}
                                    className={`focusable-red range-slider__range_settings ${!esTemaClasico && "onbackground-primary--bordered"
                                        }`}
                                    onChange={(e) => {
                                        console.log(e.currentTarget.value)
                                        cambiarEspacioTexto(e.currentTarget.value);
                                    }}
                                />
                            </div>
                            <div className="item">
                                <legend className="label text-fontSize">
                                    {textosInterfaz?.tipo_fuente || "Tipo de fuente:"}
                                </legend>
                                <div className="d-flex px-0 mt-3" role="radiogroup">
                                    {Object.values(FuentesDisponibles).map((fuente, index) => {
                                        const font =
                                            fuente?.id === "predeterminado"
                                                ? "Quicksand"
                                                : fuente?.id === "dyslexic"
                                                    ? "OpenDyslexic"
                                                    : fuente.id;

                                        const isSelected = fuente?.id === accebilidadState?.fuente;
                                        return (
                                            <div
                                                key={`fuente${index}`}
                                                className="col-3 px-0 d-flex justify-content-center"
                                            >
                                                <button
                                                    role="radio"
                                                    aria-checked={isSelected}
                                                    className={`tipo-fuente focusable-red ${isSelected && "activeMode"}`}
                                                    onClick={() => cambiarTipoFuente(fuente?.id)}
                                                >
                                                    <span
                                                        className="letra"
                                                        aria-hidden={true}
                                                        style={{
                                                            fontFamily: font,
                                                            fontWeight: index === 0 ? "600" : "500",
                                                        }}
                                                    >
                                                        {fuente?.id !== "dyslexic" ? "A" : "a"}
                                                    </span>
                                                    <span>
                                                        {textosInterfaz?.[fuente.id] || fuente?.nombre}
                                                    </span>
                                                </button>
                                            </div>
                                        );

                                    })}
                                </div>
                            </div>

                            <div className="item">
                                <legend className="label mb-0 text-fontSize">
                                    {textosInterfaz?.color_contraste || "Color y contraste:"}
                                </legend>

                                <div className="d-flex px-0" role="radiogroup">
                                    <div className="col-6 px-0">
                                        <button
                                            role="radio"
                                            aria-checked={accebilidadState?.tema === TemasDisponibles.clasico.id}
                                            className={`btn-original focusable-red`}
                                            onClick={() => {
                                                cambiarTema(TemasDisponibles.clasico.id);
                                            }}
                                        >
                                            {textosInterfaz?.[TemasDisponibles.clasico.id] || TemasDisponibles?.clasico?.nombre}
                                        </button>
                                    </div>
                                    <div
                                        role="radio"
                                        aria-checked={accebilidadState?.tema === TemasDisponibles.altoContraste.id}
                                        className="col-6 px-0"
                                        onClick={() => {
                                            cambiarTema(TemasDisponibles.altoContraste.id);
                                        }}
                                    >
                                        <button className={`btn-alto-contraste focusable-red`}>
                                            {textosInterfaz?.[TemasDisponibles.altoContraste.id] || TemasDisponibles?.altoContraste?.nombre}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <button
                                className={`reset-button text-fontSize focusable-red ${!esTemaClasico && "onprimary--border"
                                    }`}
                                onClick={() => restablecerConfiguracion()}
                            >
                                {textosInterfaz?.restablecer || "Restablecer"}
                            </button>
                            <button
                                aria-label={textosInterfaz?.button_close_accessibility_panel || "Cerrar panel de configuración de accesibilidad"}
                                className=" close-button focusable-red"
                                onClick={() => showAccessibility.setVisible(false)}
                            >
                                <Icon icon="mdi:close-thick" />
                            </button>
                        </section>
                    </FocusScope>
                )}
            </div>

        </>
    );
};